import { css } from "styled-components/macro";

// Vertical rhythm via the owl selector: a top margin between adjacent DIRECT children
// only, so nested contexts don't compound. A child can retune its gap with --flow-space.
// The margin reset makes flow the sole authority on spacing; without it, children's
// UA/GlobalStyle margins would stack onto the container padding at the first/last child.
// Interpolation-free on purpose, so it ports verbatim to a plain `.flow` class later.
export const flow = (base = "1em") => css`
  > * {
    margin-top: 0;
    margin-bottom: 0;
  }

  > * + * {
    margin-top: var(--flow-space, ${base});
  }
`;
